import React, { useState, useEffect } from "react";
import api from "../../api";

const NotificationsWidget = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.get("/v1/notifications", {
          withCredentials: true
        });
        const data = response.data || [];
        // Get last 5 notifications
        setNotifications(data.slice(0, 5));
        setLoading(false);
      } catch (err) {
        console.error("Error fetching notifications:", err);
        setLoading(false);
      }
    };
    
    fetchNotifications();
  }, []);

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  if (loading) {
    return (
      <div style={{ 
        color: "rgba(255, 255, 255, 0.7)",
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        borderRadius: "8px",
        padding: "1.5rem",
        textAlign: "center",
        border: "1px solid rgba(255, 255, 255, 0.1)"
      }}>
        <img src="/loading.gif" alt="Loading..." width="32" /> Loading notifications...
      </div>
    );
  }

  return (
    <React.Fragment>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 style={{ 
          color: "#ffffff", 
          fontWeight: "600",
          margin: 0,
          paddingLeft: "0.5rem",
          borderLeft: "3px solid rgba(139, 92, 246, 0.8)"
        }}>Recent Notifications</h5>
        <a 
          href="/notifications" 
          style={{ 
            color: "var(--theme-accent)", 
            textDecoration: "none",
            fontSize: "0.9rem",
            fontWeight: "500"
          }}
        >
          View All →
        </a>
      </div>

      {notifications.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            backgroundColor: '#1d222e',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#242836', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <th style={{ padding: '12px', textAlign: 'left', color: 'rgba(255, 255, 255, 0.7)', fontWeight: '600', fontSize: '0.85rem' }}>Avatar</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'rgba(255, 255, 255, 0.7)', fontWeight: '600', fontSize: '0.85rem' }}>Subject</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'rgba(255, 255, 255, 0.7)', fontWeight: '600', fontSize: '0.85rem' }}>Message</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'rgba(255, 255, 255, 0.7)', fontWeight: '600', fontSize: '0.85rem' }}>Time</th>
                <th style={{ padding: '12px', textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)', fontWeight: '600', fontSize: '0.85rem' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((notif, index) => {
                // Determine avatar path based on subject
                const imagePath = 
                  notif.subject === "RaceTracks" ||
                  notif.subject === "Pokemon Gift Received" ||
                  notif.subject === "Auction House" ||
                  notif.subject === "Pokédex" ||
                  notif.subject === "Pokemon Gift Sent"
                    ? `/sprites/${notif.avatar}.png`
                    : `/avatars/${notif.avatar}.png`;

                return (
                  <tr key={notif.id || index} style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.05)' }}>
                    <td style={{ padding: '12px' }}>
                      <img
                        src={imagePath}
                        alt="avatar"
                        style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                        onError={(e) => {
                          e.target.src = '/avatars/1.png';
                        }}
                      />
                    </td>
                    <td style={{ padding: '12px', color: '#ffffff', fontSize: '0.9rem', fontWeight: '500' }}>
                      {notif.subject || 'Notification'}
                    </td>
                    <td style={{ 
                      padding: '12px', 
                      color: 'rgba(255, 255, 255, 0.8)', 
                      fontSize: '0.85rem',
                      maxWidth: '300px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {notif.text || notif.message || 'No message'}
                    </td>
                    <td style={{ padding: '12px', color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                      {formatTime(notif.timesent || notif.created_at || notif.timestamp)}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      {notif.viewed === 1 ? (
                        <span style={{
                          backgroundColor: '#f59e0b',
                          color: '#000',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '0.75rem',
                          fontWeight: '600'
                        }}>New</span>
                      ) : (
                        <span style={{
                          backgroundColor: '#6c757d',
                          color: '#fff',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '0.75rem',
                          fontWeight: '600'
                        }}>Viewed</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ 
          color: "rgba(255, 255, 255, 0.7)",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          borderRadius: "8px",
          padding: "2rem",
          textAlign: "center",
          border: "1px solid rgba(255, 255, 255, 0.1)"
        }}>
          <i className="ri-notification-off-line" style={{ fontSize: "2.5rem", marginBottom: "0.5rem", opacity: 0.5 }}></i>
          <p style={{ margin: 0 }}>No new notifications</p>
        </div>
      )}
    </React.Fragment>
  );
};

export default NotificationsWidget;
